// list of nodes in where the index matches the pdf id
// node consists of image, result image, result text, pdf id
const pdfResults = [
  {},
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_RL_1.png"
        style={{ width: "45%", height: "100%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "Both scripts appear on the same page or spread. Latin text blocks are set right to left against the script’s normal textual direction, ie Latin readers will flip pages right to left.",
    resultArabText:
      "يظهر النّصّان العربي واللاتيني على الصفحة نفسها او على صفحتين متقابلتين. ويبدو اتجاه القراءة لمقاطع النص اللاتيني من اليمين الى اليسار وذلك على عكس الاتجاه الطبيعي لقراءته وكتابته. أي أن القارئ سوف يضطر أن يقلب الصفحات من اليمين الى اليسار.",
    pdfID: 1,
    previewImage: "/icons/previewIcons/previewRL1.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_RL_2.png"
        style={{ width: "45%", height: "100%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "Both scripts appear on the same page or spread. Latin is set at a 90˚angle which compels the reader to rotate the book 90˚.",
    resultArabText:
      "يظهر النّصّان العربي واللاتيني على الصفحة نفسها او على صفحتين متقابلتين. النص اللاتيني يكون معكوساً بـزاوية 90 درجة مِمّا يُجبِر القارىء على تدوير الكتاب بزاوية 90 درجة للتمكن من القراءة. ",
    pdfID: 2,
    previewImage: "/icons/previewIcons/previewRL2.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_RL_3.png"
        style={{ width: "45%", height: "100%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "*NOT RECOMMENDED. Since the two scripts are split, the designer might as well make the Latin run naturally from left to right.",
    resultArabText:
      "*لا يُنصَح بهذه الحالة بما أنّ النصان منفصلان تماماً، فعلى المصمّم أن يُبقي اتجاه كتابة وقراءة النص اللاتيني أيضاً على وضعه الطبيعي أي من اليسار الى اليمين.",
    pdfID: 3,
    previewImage: "/icons/previewIcons/previewRL3.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_RL_4.png"
        style={{ width: "100%", height: "100%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "*NOT RECOMMENDED. Since the two scripts are split, the designer might as well make the Latin run from the opposite reading direction. Book-in-Book structure.",
    resultArabText:
      "*لا يُنصَح بهذه الحالة  بما أنّ النصان منفصلان تماماً، فعلى المصمّم أن يُبقي اتجاه كتابة وقراءة النص اللاتيني أيضاً على وضعه الطبيعي أي من اليسار الى اليمين.  كتاب ضمن كتاب.",
    pdfID: 4,
    previewImage: "/icons/previewIcons/previewRL4.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_RL_5.png"
        style={{ width: "100%", height: "100%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "Latin is set at a 90˚angle which compels the reader to rotate the book 90˚. Book-in-book structure.",
    resultArabText:
      "النص اللاتيني مقلوباً بزاوية 90 درجة ما يجعل القارىء مضطراً الى تدوير الكتاب بـ 90 درجة للتمكن من القراءة.  كتاب ضمن كتاب.",
    pdfID: 5,

    previewImage: "/icons/previewIcons/previewRL5.svg",
  },

  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_RL_6.png"
        style={{ width: "45%", height: "100%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "Latin is set at a 90˚angle which compels the reader to rotate the book 90˚. Two-books-in-one structure.",
    resultArabText:
      "النص اللاتيني مقلوباً بزاوية 90 درجة ما يجعل القارىء مظطراً الى تدوير الكتاب بـ 90 درجة للتمكن من القراءة. كتابين في كتاب.",
    pdfID: 6,
    previewImage: "/icons/previewIcons/previewRL6.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_LR_1.png"
        style={{ width: "45%", height: "100%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "Both scripts appear on the same page or spread. Arabic text blocks are set left to right against the script’s normal textual direction, ie Arabic readers will flip left to right.",
    resultArabText:
      "يظهر النّصّان العربي واللاتيني على الصفحة نفسها او على صفحتين متقابلتين. ويبدو اتجاه القراءة لمقاطع النص العربي من اليسار الى اليمين وذلك على عكس الاتجاه الطبيعي لقراءته وكتابته. أي أن القارئ سوف يضطر أن يقلب الصفحات من اليسار الى اليمين.",
    pdfID: 7,
    previewImage: "/icons/previewIcons/previewLR1.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_LR_2.png"
        style={{ width: "45%", height: "100%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "Both scripts appear on the same page or spread. Arabic is set at a 90˚angle which compels the reader to rotate the book 90˚.",
    resultArabText:
      "يظهر النّصّان العربي واللاتيني على الصفحة نفسها او على صفحتين متقابلتين. النص العربي يكون معكوساً بـزاوية 90 درجة مِمّا يُجبِر القارىء على تدوير الكتاب بزاوية 90 درجة للتمكن من القراءة",

    pdfID: 8,
    previewImage: "/icons/previewIcons/previewLR2.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_LR_3.png"
        style={{ width: "45%", height: "100%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "*NOT RECOMMENDED. Since the two scripts are split, the designer might as well make the Arabic run naturally from right to left.Two-books-in-one structure.",
    resultArabText:
      "*لا يُنصَح بهذه الحالة بما أنّ النّصان منفصلان تماماً، فعلى المصمّم أن يُبقي اتجاه كتابة وقراءة النص العربي أيضاً على وضعه الطبيعي أي من اليمين الى اليسار. كتابين في كتاب.",
    pdfID: 9,
    previewImage: "/icons/previewIcons/previewLR3.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_LR_4.png"
        style={{ width: "100%", height: "100%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "*NOT RECOMMENDED. Since the two scripts are split, the designer might as well make the Arabic run from the opposite reading direction. Book-in-book structure.",
    resultArabText:
      "*لا يُنصَح بهذه الحالة بما أنّ النصان منفصلان تماماً، فعلى المصمّم أن يبقي اتجاه كتابة وقراءة النص العربي أيضاً على وضعه الطبيعي أي من  اليمين الى اليسار. كتاب ضمن كتاب.",
    pdfID: 10,
    previewImage: "/icons/previewIcons/previewLR4.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_LR_5.png"
        style={{ width: "100%", height: "100%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "Arabic is set at a 90˚angle which compels the reader to rotate the book 90˚. Book-in-book structure.",
    resultArabText:
      "النص العربي مقلوباً بزاوية 90 درجة ما يجعل القارىء مضطراً الى تدوير الكتاب بـ 90 درجة للتمكن من القراءة. كتاب ضمن كتاب.",
    pdfID: 11,
    previewImage: "/icons/previewIcons/previewLR5.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_LR_6.png"
        style={{ width: "45%", height: "100%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "Arabic is set at a 90˚angle which compels the reader to rotate the book 90˚. Two-books-in-one structure.",
    resultArabText:
      "النص العربي مقلوباً بزاوية 90 درجة ما يجعل القارىء مضطراً الى تدوير الكتاب بـ 90 درجة للتمكن من القراءة. كتاب ضمن كتاب.",
    pdfID: 12,
    previewImage: "/icons/previewIcons/previewLR6.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_RL_LR_1.png"
        style={{ width: "85%", height: "100%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "Both scripts appear on the same page or spread. Arabic text will start where Latin ends and vice versa, crossing each other. ",
    resultArabText:
      "يظهر النّصّان العربي واللاتيني على الصفحة نفسها او على صفحتين متقابلتين. ييدأ النص العربي من حيث ينتهي النص اللاتيني متداخلين ببعضهما البعض، والعكس صحيح.",
    pdfID: 13,
    previewImage: "/icons/previewIcons/previewRLLR1.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_RL_LR_2.png"
        style={{ width: "85%", height: "100%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "*NOT RECOMMENDED unless the 90˚ angle is a stylistic choice. Latin is set at a 90˚angle which compels the reader to rotate the book 90˚. Both scripts appear on the same page or spread. Arabic text will start where Latin ends and vice versa, crossing each other. ",
    resultArabText:
      "*لا يُنصَح بالحالة التالية الا للضرورات الجمالية. ويتم فيه قلب النص اللاتيني بزاوية 90 درجة ما يجعل القارىء مجبراً على تدوير الكتاب بنفس الدرجة للتمكن من القراءة. يظهر النّصّان العربي واللاتيني على الصفحة نفسها او على صفحتين متقابلتين. ييدأ النص العربي من حيث ينتهي النص اللاتيني متداخلين ببعضهما البعض، والعكس صحيح.",
    pdfID: 14,
    previewImage: "/icons/previewIcons/previewRLLR2.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_RL_LR_3.png"
        style={{ width: "85%", height: "100%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "*NOT RECOMMENDED unless the 90˚ angle is a stylistic choice. Arabic is set at a 90˚ angle which compels the reader to rotate the book 90˚. Both scripts appear on the same page or spread. Arabic text will start where Latin ends and vice versa, crossing each other.",
    resultArabText:
      "*لا يُنصَح بالحالة التالية الا للضرورات الجمالية. ويتم فيه قلب النص العربي بزاوية 90 درجة ما يجعل القارىء مجبراً على تدوير الكتاب بنفس الدرجة للتمكن من القراءة. يظهر النّصّان العربي واللاتيني على الصفحة نفسها او على صفحتين متقابلتين. ييدأ النص العربي من حيث ينتهي النص اللاتيني متداخلين ببعضهما البعض، والعكس صحيح.",
    pdfID: 15,
    previewImage: "/icons/previewIcons/previewRLLR3.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_RL_LR_4.png"
        style={{ width: "85%", height: "100%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "Both scripts appear on the same page or spread. The reader needs to rotate the book 180˚ to access the other language. Arabic text will start where Latin ends and vice versa, crossing each other.",
    resultArabText:
      "يظهر النّصّان العربي واللاتيني على الصفحة نفسها او على صفحتين متقابلتين. يحتاج القارىء الى تدوير الكتاب على محوره بزاوية 180 درجة ليتكمن من قراءة اللغة الأخرى. ييدأ النص العربي من حيث ينتهي النص اللاتيني متداخلين ببعضهما البعض، والعكس صحيح.",
    pdfID: 16,
    previewImage: "/icons/previewIcons/previewRLLR4.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_RL_LR_5.png"
        style={{ width: "100%", height: "100%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "Arabic script is given priority as it encloses the Latin from both ends of the book. To read the Latin script, the reader needs to flip the book. Book-in-book structure.",
    resultArabText:
      "الأولية للنص العربي في هذه الحالة، حيث يظهر في بداية الكتاب كما في نهايته (أي من الجهتين) حاضناً النص اللاتيني في وسط الكتاب. لقراءة النص اللاتيني على القارئ أن يقوم بقلب (عكس اتجاه) الكتاب. كتاب ضمن كتاب.",
    pdfID: 17,
    previewImage: "/icons/previewIcons/previewRLLR5.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_RL_LR_6.png"
        style={{ width: "100%", height: "100%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "Latin script is given priority as it encloses the Arabic from both ends of the book. To read the Arabic script, the reader needs to flip the book. Book-in-book structure.",
    resultArabText:
      "الأولية للنص اللاتيني في هذه الحالة، حيث يظهر في بداية الكتاب كما في نهايته (أي من الجهتين) حاضناً النص العربي في وسط الكتاب. لقراءة النص العربي على القارئ أن يقوم بقلب (عكس اتجاه) الكتاب. كتاب ضمن كتاب.",
    pdfID: 18,
    previewImage: "/icons/previewIcons/previewRLLR6.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_RL_LR_7.png"
        style={{ width: "55%", height: "100%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "Arabic script is given priority. To read the Latin script, the reader needs to rotate the book 90˚ and flip it. Two-books-in-one structure.",
    resultArabText:
      "الأولية للنص العربي في هذه الحالة. لقراءة النص اللاتيني، على القارئ أن يقوم بتدوير الكتاب بزاوية 90 درجة وقلبه (وعكسه) أيضاً. كتابين في كتاب.",
    pdfID: 19,
    previewImage: "/icons/previewIcons/previewRLLR7.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_RL_LR_8.png"
        style={{ width: "55%", height: "100%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "Latin script is given priority. To access the Arabic script, the reader needs to rotate the book 90˚and flip it. Two-books-in-one structure.",
    resultArabText:
      "الأولية للنص اللاتيني في هذه الحالة. لقراءة النص العربي، على القارئ أن يقوم بتدوير الكتاب بزاوية 90 درجة وقلبه (وعكسه) أيضاً. كتابين في كتاب.",
    pdfID: 20,
    previewImage: "/icons/previewIcons/previewRLLR8.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_RL_LR_9.png"
        style={{ width: "100%", height: "100%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "Arabic script is given priority as it encloses the Latin from both ends of the book. To access the Latin script, the reader needs to rotate the book 180˚. Book-in-book structure.",
    resultArabText:
      "الأولية للنص العربي في هذه الحالة، حيث يظهر في بداية الكتاب كما في نهايته (أي من الجهتين) حاضناً النص اللاتيني في وسط الكتاب. لقراءة النص اللاتيني، على القارئ أن يقوم بتدوير الكتاب على محوره بزاوية 180 درجة. كتاب ضمن كتاب.",
    pdfID: 21,
    previewImage: "/icons/previewIcons/previewRLLR9.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_RL_LR_10.png"
        style={{ width: "100%", height: "100%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "Latin script is given priority as it encloses the Arabic from both ends of the book. To access the Arabic script, the reader needs to rotate the book 180˚. Book-in-book structure.",
    resultArabText:
      "الأولية للنص اللاتيني في هذه الحالة، حيث يظهر في بداية الكتاب كما في نهايته (أي من الجهتين) حاضناً النص العربي في وسط الكتاب. لقراءة النص العربي، على القارئ أن يقوم بتدوير الكتاب على محوره بزاوية 180 درجة. كتاب ضمن كتاب.",
    pdfID: 22,
    previewImage: "/icons/previewIcons/previewRLLR10.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_RL_LR_11.png"
        style={{ width: "55%", height: "100%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "Typical bilingual setting where the two scripts run regularly to meet in the middle of the book. Two-books-in-one structure.",
    resultArabText:
      "الحفاظ على الاتجاه الطبيعي لكل لغة على حدى، حيث يبدأ كل نص من الجهة الطبيعية له ويلتقيان في منتصف الكتاب. كتابين في كتاب.",
    pdfID: 23,
    previewImage: "/icons/previewIcons/previewRLLR11.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_RL_LR_12.png"
        style={{ width: "55%", height: "100%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "Arabic script is given priority. It runs regularly from right to left until the middle of the book where the reader rotates the book 180˚and continues to read the Latin. Two-books-in-one structure.",
    resultArabText:
      "الأولية للنص العربي في هذه الحالة، لتبدأ القراءة بشكلها الطبيعي من اليمين الى اليسار حتى منتصف الكتاب حيث يضطر القارىء الى تدوير الكتاب 180 درجة ليتمكن مواصلة قراءة اللغة اللاتينية. كتاب ضمن كتاب.",
    pdfID: 24,
    previewImage: "/icons/previewIcons/previewRLLR12.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_RL_LR_13.png"
        style={{ width: "55%", height: "100%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "Latin script is given priority. it  runs regularly from left to right until the middle of the book where the reader rotates the book 180˚and continues to read Arabic. Two-books-in-one structure.",
    resultArabText:
      "الأولية للنص اللاتيني في هذه الحالة، لتبدأ القراءة بشكلها الطبيعي من اليسار الى اليمين حتى منتصف الكتاب حيث يضطر القارىء الى تدوير الكتاب 180 درجة ليتمكن مواصلة قراءة اللغة العربية. كتاب ضمن كتاب.",
    pdfID: 25,
    previewImage: "/icons/previewIcons/previewRLLR13.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_vertical_1.png"
        style={{ height: "85%", width: "60%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "Both scripts appear on the same page or spread. Arabic text will start where Latin ends and vice versa, crossing each other.",
    resultArabText:
      "يظهر النّصّان العربي واللاتيني على الصفحة نفسها او على صفحتين متقابلتين. ييدأ النص العربي من حيث ينتهي النص اللاتيني والعكس صحيح، متداخلين ببعضهما البعض.",
    pdfID: 26,
    previewImage: "/icons/previewIcons/previewVertical1.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_vertical_2.png"
        style={{ height: "85%", width: "60%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "Both scripts appear on the same page or spread, running in parallel with each other.",
    resultArabText:
      "يظهر النّصّان العربي واللاتيني على الصفحة نفسها او على صفحتين متقابلتين، حيث تُقرأ النصوص بالتوازي مع بعضها البعض.",
    pdfID: 27,
    previewImage: "/icons/previewIcons/previewVertical2.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_vertical_3.png"
        style={{ height: "85%", width: "60%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "Arabic script is given priority as it encloses the Latin from both ends of the book. To access the Latin script, the reader needs to flip the book. Book-in-book structure.",
    resultArabText:
      "الأولية للنص العربي، حيث يظهر في بداية الكتاب كما في نهايته (أي من الجهتين) حاضناً النص اللاتيني في وسط الكتاب. لقراءة النص اللاتيني على القارئ أن يقوم بقلب الكتاب. كتاب ضمن كتاب.",
    pdfID: 28,
    previewImage: "/icons/previewIcons/previewVertical3.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_vertical_4.png"
        style={{ height: "85%", width: "60%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "Latin script is given priority as it encloses the Arabic from both ends of the book. To access the Arabic script, the reader needs to flip the book. Book-in-book structure.",
    resultArabText:
      "الأولية للنص اللاتيني، حيث يظهر في بداية الكتاب كما في نهايته (أي من الجهتين) حاضناً النص العربي في وسط الكتاب. لقراءة النص العربي على القارئ أن يقوم بقلب الكتاب. كتاب ضمن كتاب.",
    pdfID: 29,
    previewImage: "/icons/previewIcons/previewVertical4.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_vertical_5.png"
        style={{ height: "85%", width: "60%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "Both scripts run regularly until they meet in the middle of the book. To access either scripts, the reader needs to flip horizontally.",
    resultArabText:
      "يبدأ كل نص من الاتجاه الصحيح للّغة ليلتقي النّصان في منتصف الكتاب. للقراءة باللغة المطلوبة، على القارىء ان يقلب الكتاب أفقياً.",
    pdfID: 30,
    previewImage: "/icons/previewIcons/previewVertical5.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_vertical_6.png"
        style={{ height: "85%", width: "60%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "Arabic script is given priority as it encloses the Latin from both ends of the book. Book-in-book structure.",
    resultArabText:
      "الأولية للنص العربي، حيث يظهر في بداية الكتاب كما في نهايته (أي من الجهتين) حاضناً النص اللاتيني في وسط الكتاب. كتاب ضمن كتاب.",
    pdfID: 31,
    previewImage: "/icons/previewIcons/previewVertical6.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_vertical_7.png"
        style={{ height: "85%", width: "60%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "Latin script is given priority as it encloses the Arabic from both ends of the book. Book-in-book structure.",
    resultArabText:
      "الأولية للنص اللاتيني، حيث يظهر في بداية الكتاب كما في نهايته (أي من الجهتين) حاضناً النص العربي في وسط الكتاب. كتاب ضمن كتاب.",
    pdfID: 32,
    previewImage: "/icons/previewIcons/previewVertical7.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_vertical_8.png"
        style={{ height: "85%", width: "60%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      "Arabic script is given priority as it is the starting script. It runs regularly from top to bottom until the middle of the book where the reader continues with the Latin. Two-books-in-one structure.",
    resultArabText:
      "الأولوية للّغة العربية بما انها اللغة التي يتم البدء بها. تُقرأ بالاتجاه الطبيعي من الأعلى الى الأسفل وذلك حتى منتصف الكتاب حيث تتم مواصلة القراءة باللغة اللاتينية. كتابين في كتاب.",
    pdfID: 33,
    previewImage: "/icons/previewIcons/previewVertical8.svg",
  },
  {
    title: "structure title عنوان الهيكل",
    image: (
      <img
        src="/images/resultIcons/result_vertical_9.png"
        style={{ height: "85%", width: "60%" }}
        alt="ResultIcon"
      />
    ),
    resultEngText:
      " Latin script is given priority as it is the starting script. It runs regularly from top to bottom until the middle of the book where the reader continues to read the Arabic. Two-books-in-one structure.",
    resultArabText:
      "الأولوية للّغة اللاتينية بما انها اللغة التي يتم البدء بها. تُقرأ بالاتجاه الطبيعي من الأعلى الى الأسفل وذلك حتى منتصف الكتاب حيث تتم مواصلة القراءة باللغة العربية. كتابين في كتاب.",
    pdfID: 34,
    previewImage: "/icons/previewIcons/previewVertical9.svg",
  },
];

export default pdfResults;
